import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const ChatAIPage: React.FC = () => {
  const history = useHistory();

  const handleBackToHome = () => {
    history.push("/");
  };

  return (
    <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", position: "relative" }}>
      {/* Nút back đè lên header của web nhúng */}
      <button
        onClick={handleBackToHome}
        style={{
          position: "absolute",
          top: "22px",
          left: "12px",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "36px",
          height: "36px",
          border: "none",
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.9)",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          transition: "all 0.2s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "white";
          e.currentTarget.style.transform = "scale(1.05)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.9)";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <ArrowLeft size={20} color="#1a9ba7" />
      </button>

      <iframe
        src="https://viags-gpt.azurewebsites.net"
        frameBorder={0}
        style={{ width: "100%", height: "100%", border: "none" }}
        title="Copilot Studio Webchat"
        allow="autoplay; clipboard-write; encrypted-media"
      />
    </div>
  );
};

export default ChatAIPage;
